import React from "react";
import Button from "react-bootstrap/esm/Button";
import ActionTypeEnum from "../../enums/action-type.enum";
import PriorityEnum from "../../enums/priority.enum";
import SizeEnum from "../../enums/size.enum";
import classMap from "../../helpers/classMap";
import FaIcon from "../fa-icon/fa-icon";
import ButtonIconProps from "./button-icon.props";

const ButtonIcon = (props: ButtonIconProps) => {
  const styleClass: string = (props.style && props.style === "rounded" ? "badge-pill" : props.style) || "";

  const content: JSX.Element = <FaIcon {...{ ...props.icon, title: props.text }} />;

  const clickHandler = (event: any) => {
    event.stopPropagation();
    if (props.callback) props.callback();
  };

  return (
    <Button
      aria-label={props.text || props.ariaLabel || "button"}
      variant={props.priority || PriorityEnum.PRIMARY}
      size={props.size && props.size !== SizeEnum.MEDIUM ? props.size : SizeEnum.LARGE}
      disabled={props.enabled !== undefined ? !props.enabled : false}
      onClick={clickHandler}
      type={props.type || ActionTypeEnum.BUTTON}
      tabIndex={props.tabIndex ?? undefined}
      className={classMap("mpng-ux-buttonicon shape", styleClass, props.className)}
    >
      {content}
    </Button>
  );
};

export default ButtonIcon;
